import React, { useEffect } from 'react';
import DocumentInfo from '../DocumentInfo/DocumentInfo';
import useDocumentTypeListQuery from '../../queries/useDocumentTypeListQuery';
import useDocsOrdTypesQuery from '../../queries/useDocsOrdTypesQuery';
import useDocsSubtypesQuery from '../../queries/useDocsSubtypesQuery';
import { docTypes } from '../../constants/documents.constants';
import useCompanies from '../../../../queries/useCompanies';
import { useSelector } from 'react-redux';
import { documentDrawerSelector } from '../../store/selectors/new-document.selector';
import { getDocOptionsSelect } from '../../utils/getDocOptionsSelect';

const DocumentInfoContainer = ({ form }) => {
  const { data, isFetching } = useDocumentTypeListQuery();
  const { data: ordTypes = [], isFetching: isOrdTypesFetching } =
    useDocsOrdTypesQuery();
  const { data: subtypes = [], isFetching: isSubtypesFetching } =
    useDocsSubtypesQuery(docTypes.meeting);
  const {
    data: subtypesContract = [],
    isFetching: isSubtypesContractFetching,
  } = useDocsSubtypesQuery(docTypes.contract);
  const { data: subtypesOutgoing = [], isFetching: isOutgoingFetching } =
    useDocsSubtypesQuery(docTypes.outgoing);
  const {
    data: subtypesIncoming = [],
    isFetching: isSubtypesIncomingFetching,
  } = useDocsSubtypesQuery(docTypes.incoming);
  const { data: companyList = [], isFetching: isCompanyFetching } =
    useCompanies();

  const { mode } = useSelector(documentDrawerSelector);

  const isCreate = mode === 'create';

  const serviceCompanyIdValue = form.getFieldValue('serviceCompanyId');

  useEffect(() => {
    if (
      isCreate &&
      !isFetching &&
      companyList.length === 1 &&
      !serviceCompanyIdValue
    ) {
      form.setFieldsValue({ serviceCompanyId: companyList[0].id });
    }
  }, [isCreate, companyList, isFetching, serviceCompanyIdValue, form]);

  return (
    <DocumentInfo
      form={form}
      type={{ data: getDocOptionsSelect(data), isFetching }}
      ordType={{
        data: getDocOptionsSelect(ordTypes),
        isFetching: isOrdTypesFetching,
      }}
      subtype={{
        data: getDocOptionsSelect(subtypes),
        isFetching: isSubtypesFetching,
      }}
      subtypesContract={{
        data: getDocOptionsSelect(subtypesContract),
        isFetching: isSubtypesContractFetching,
      }}
      subtypesOutgoing={{
        data: getDocOptionsSelect(subtypesOutgoing),
        isFetching: isOutgoingFetching,
      }}
      subtypesIncoming={{
        data: getDocOptionsSelect(subtypesIncoming),
        isFetching: isSubtypesIncomingFetching,
      }}
      company={{
        data: getDocOptionsSelect(companyList),
        isFetching: isCompanyFetching,
      }}
    />
  );
};

export default DocumentInfoContainer;
